import React, { useState, useEffect } from 'react';
import {
  Card,
  CardHeader,
  Container,
  Row, Button, Modal, ModalBody, ModalFooter,
  UncontrolledTooltip, FormGroup, Col, Input, Label, NavLink
} from "reactstrap";
import { Form, Field } from "react-final-form";
import iconSet from "selection.json";
import IcomoonReact, { iconList } from "icomoon-react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
import dataProvider from "dataProvider";
import { useHistory } from "react-router-dom";
import auth from "authProvider";


const Permission = (props) => {
  const history = useHistory();
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(false)
  const [modalOpen, setModalOpen] = React.useState(false);
  const [modalOpenper, setModalOpenper] = React.useState(false);

  useEffect(() => {
    dataProvider.getList('users', { params: { pagination: { page: 1, perPage: 20 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => {
        if (data && data.length > 0) {
          const arr = data.find(word => word.id === props.location.state);
          setPermissions(arr?.permissions)
        }
      })
      .catch(error => { console.log(error) });
  }, [props]);

  const onChangePermission = (val, key) => {
    if (val) {
      setPermissions(prevState => [...prevState, key]);
    }
    else {
      let arrAfterRemove = permissions.filter(item => item !== key)
      setPermissions(arrAfterRemove);
    }
  }

  const onLogout = () => {
    auth.logout();
    history.push("/")
  }
  const onSubmit = () => {
    setLoading(true)
    dataProvider.update('users', { id: props.location.state, params: { permissions: permissions } })
      .then(({ data }) => {
        setModalOpenper(true)
        setLoading(false)
        // history.push("/users")
      })
      .catch(error => {
        if (error?.response?.data?.expire === true) {
          setModalOpen(true)
        }
      });
  };

  return (
    <>
      <div className="header pb-8 pt-5 pt-md-6" style={{
        width: '100%',
        backgroundImage:
          "url(" +
          require("../../../assets/img/brand/header.jpg").default +
          ")",
      }}>
        <Container fluid >
          <div className="header-body">
            {/* header*/}
            <Row style={{ color: 'white', fontSize: '1.25rem', paddingLeft: '20px', flexDirection: 'row', justifyContent: 'space-between' }}>
              <h2 className="mb-0" style={{ color: 'white', alignContent: 'flex-start', fontSize: '1.5rem', marginLeft: 10 }}>PERMISSION</h2>
              <div style={{ alignContent: 'flex-end', marginRight: '20px' }}>
                <Link to="/users/create"><Button style={{ backgroundColor: 'white', fontSize: '0.625rem', padding: '10px', borderRadius: '30px', border: 0, color: '#064481', fontWeight: 'bolder' }}>  <IcomoonReact iconSet={iconSet} color="#064481" size={14} icon="add" />  CREATE USER</Button>{' '}</Link>
                <Link to="/users/tenant"><Button style={{ backgroundColor: 'rgb(219 219 147)', fontSize: '0.625rem', padding: '10px', borderRadius: '30px', border: 0, color: '#064481', fontWeight: 'bolder' }}>  <IcomoonReact iconSet={iconSet} color="#064481" size={14} icon="add" />  CREATE TENANT</Button>{' '}</Link>
              </div>
            </Row>

          </div>
        </Container>
      </div>
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow">
              <Row>
                <div className="col">
                  <Card className="shadow">
                    <CardHeader className="border-0">
                      <h3 className="mb-0">CHOOSE PERMISSION</h3>
                    </CardHeader>
                    <Form
                      onSubmit={onSubmit}
                      render={({ handleSubmit, values, submitting, validating, valid }) => (
                        <form onSubmit={handleSubmit} style={{ padding: '20px' }}>
                          <div className="col">
                            <div style={{ marginTop: '20px' }} className="pl-lg">
                              <Row>
                                <Col lg="2">
                                  <label style={{ paddingLeft: '20px' }}
                                    className="form-control-label"
                                    htmlFor="input-city"
                                  >
                                    Technicians
                                  </label>
                                  <div style={{ paddingLeft: '20px' }}>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('technician_add') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'technician_add')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Add</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('technician_edit') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'technician_edit')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}>Edit</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('technician_delete') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'technician_delete')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Delete</span>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Col>
                                <Col lg="2">
                                  <label style={{ paddingLeft: '20px' }}
                                    className="form-control-label"
                                    htmlFor="input-city"
                                  >
                                    Tenants
                                  </label>
                                  <div style={{ paddingLeft: '20px' }}>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('tenants_add') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'tenants_add')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Add</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('tenants_edit') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'tenants_edit')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}>Edit</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('tenants_delete') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'tenants_delete')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Delete</span>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Col>
                                <Col lg="2">
                                  <label style={{ paddingLeft: '20px' }}
                                    className="form-control-label"
                                  >
                                    Banners
                                  </label>
                                  <div style={{ paddingLeft: '20px' }}>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('banner_add') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'banner_add')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Add</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('banner_edit') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'banner_edit')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}>Edit</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('banner_delete') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'banner_delete')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Delete</span>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Col>
                                <Col lg="2">
                                  <label style={{ paddingLeft: '20px' }}
                                    className="form-control-label"
                                  >
                                    Category
                                  </label>
                                  <div style={{ paddingLeft: '20px' }}>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('category_add') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'category_add')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Add</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('category_edit') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'category_edit')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}>Edit</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('category_delete') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'category_delete')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Delete</span>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Col>
                                <Col lg="2">
                                  <label style={{ paddingLeft: '20px' }}
                                    className="form-control-label"
                                  >
                                    Location
                                  </label>
                                  <div style={{ paddingLeft: '20px' }}>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('location_add') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'location_add')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Add</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('location_edit') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'location_edit')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}>Edit</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('location_delete') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'location_delete')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Delete</span>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Col>
                                <Col lg="2">
                                  <label style={{ paddingLeft: '20px' }}
                                    className="form-control-label"
                                  >
                                    Notification
                                  </label>
                                  <div style={{ paddingLeft: '20px' }}>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('notification_add') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'notification_add')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Add</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('notification_edit') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'notification_edit')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}>Edit</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('notification_delete') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'notification_delete')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Delete</span>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                            <div style={{ marginTop: '20px' }} className="pl-lg">
                              <Row>
                                <Col lg="2">
                                  <label style={{ paddingLeft: '20px' }}
                                    className="form-control-label"
                                    htmlFor="input-city"
                                  >
                                    Services
                                  </label>
                                  <div style={{ paddingLeft: '20px' }}>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('services_add') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'services_add')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Add</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('services_edit') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'services_edit')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}>Edit</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('services_delete') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'services_delete')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Delete</span>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Col>
                                <Col lg="2">
                                  <label style={{ paddingLeft: '20px' }}
                                    className="form-control-label"
                                  >
                                    Places
                                  </label>
                                  <div style={{ paddingLeft: '20px' }}>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('places_add') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'places_add')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Add</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('places_edit') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'places_edit')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}>Edit</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('places_delete') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'places_delete')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Delete</span>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Col>
                                <Col lg="2">
                                  <label style={{ paddingLeft: '20px' }}
                                    className="form-control-label"
                                  >
                                    Parts Inventory
                                  </label>
                                  <div style={{ paddingLeft: '20px' }}>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('parts_add') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'parts_add')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Add</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('parts_edit') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'parts_edit')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}>Edit</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('parts_delete') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'parts_delete')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Delete</span>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Col>
                                <Col lg="2">
                                  <label style={{ paddingLeft: '20px' }}
                                    className="form-control-label"
                                  >
                                    Priority
                                  </label>
                                  <div style={{ paddingLeft: '20px' }}>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('priority_add') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'priority_add')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Add</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('priority_edit') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'priority_edit')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}>Edit</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('priority_delete') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'priority_delete')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Delete</span>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Col>
                                <Col lg="2">
                                  <label style={{ paddingLeft: '20px' }}
                                    className="form-control-label"
                                  >
                                    Users
                                  </label>
                                  <div style={{ paddingLeft: '20px' }}>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('users_add') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'users_add')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Add</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('users_edit') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'users_edit')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}>Edit</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('users_delete') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'users_delete')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Delete</span>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Col>
                                <Col lg="2">
                                  <label style={{ paddingLeft: '20px' }}
                                    className="form-control-label"
                                  >
                                    Workorder
                                  </label>
                                  <div style={{ paddingLeft: '20px' }}>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('workorder_add') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'workorder_add')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Add</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('workorder_edit') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'workorder_edit')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}>Edit</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('workorder_delete') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'workorder_delete')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Delete</span>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                            <div style={{ marginTop: '20px' }} className="pl-lg">
                              <Row>
                                <Col lg="2">
                                  <label style={{ paddingLeft: '20px' }}
                                    className="form-control-label"
                                  >
                                    Settings
                                  </label>
                                  <div style={{ paddingLeft: '20px' }}>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('settings_add') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'settings_add')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Add</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('settings_edit') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'settings_edit')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}>Edit</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" checked={permissions.includes('settings_delete') ? true : false} onChange={(e) => onChangePermission(e.target.checked, 'settings_delete')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Delete</span>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </div>
                          <div style={{ paddingBottom: '30px', padding: '20px' }}>
                            <NavLink id="nav-link" href="/users/create"><Button onClick={loading} type="submit" style={{ backgroundColor: loading ? 'green' : 'rgb(0 139 183)', padding: '10px', color: 'white', width: '30%', borderRadius: '10px', border: 0 }} >SUBMIT</Button>{' '}
                            </NavLink>
                          </div>
                        </form>
                      )}
                    />
                  </Card>
                </div>
              </Row>
            </Card>
          </div>
        </Row>
      </Container>
      <Modal isOpen={modalOpen} size="sm">
        <ModalBody style={{ backgroundColor: 'rgb(219 219 147)', color: 'red' }}>Your session has expired. Please sign in again.</ModalBody>
        <ModalFooter>
          <Button onClick={() => onLogout()} style={{ backgroundColor: '#09577C', color: 'white' }} type="button">
            LOGOUT
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modalOpenper} size="sm">
        <ModalBody style={{ color: 'red' }}>You Changed the permission status,Please sign in again...!</ModalBody>
        <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: 20 }}>
          <Button onClick={() => onLogout()} style={{ backgroundColor: '#ef758f', color: 'white', border: 0 }} type="button">
            LOGOUT
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default Permission;
